<template>
  <el-transfer
    v-model="selectedStockTakings"
    filterable
    :data="stockTakings"
    :titles="['Összes leltár', 'Kiválasztott leltárak']"
    :props="{
      key: 'id',
      label: 'receipt_number'
    }"
    @change="onSelectedStockTakingsChange"
  />
</template>
<script>
  export default {
    props: ['reportStockTakings', 'dialogType'],
    data() {
      return {
        selectedStockTakings: [],
        stockTakings: [],
      }
    },
    watch: {
      reportStockTakings(newVal) {
        this.selectedStockTakings = newVal && newVal.map(stockTaking => stockTaking.id);
        this.$emit('selectedStockTakingsChange', this.selectedStockTakings);
      }
    },
    async mounted() {
      this.stockTakings = await axios.get('api/stock-takings/all?exceptStorageUser');
      this.stockTakings = this.stockTakings.filter(st => st.status === 'done');
      if(this.dialogType === 'view') {
        this.stockTakings = this.stockTakings.map(st => (
          {
            ...st,
            disabled: true
          }
        ));
      }
    },
    methods: {
      onSelectedStockTakingsChange() {
        this.$emit('selectedStockTakingsChange', this.selectedStockTakings);
      }
    }
  }
</script>
<style>
  .el-transfer-panel {
    width: 300px;
  }

</style>
